import axios from "axios";
import _ from "lodash";
import { DateTime } from "luxon";
import Cookies from "js-cookie";

const siteURL = window.location.origin;
const baseURL = `${siteURL}/wp-json/wp/v2/`;
const mainURL = `${baseURL}cpt_location/`;
const urlAPI = `${mainURL}?orderby=title&order=asc&per_page=100&_embed`;

let question = "";

jQuery(($) => {
  /****************** Initialize Maps ******************/

  if (GetURLParameter("q")) {
    question = GetURLParameter("q");
  }
  initialLocations(question);

  /****************** NAV FOLLOW PARENT LINKS ************/

  $(".dropdown-toggle").on("click", () => {
    location.href = $(this).attr("href");
  });

  /****************** MENU BAR ******************/

  $("body.page-id-1293 .menu-city-changer").on(
    "change",
    "#city-changer",
    function () {
      const location = $(this)
        .find("option:selected")
        .text()
        .replace(" ", "-")
        .replace(",", "");
      window.location.replace(`/locations/${location.toLowerCase()}/menu`);
    },
  );

  /****************** LOCATION SEARCH BAR ******************/

  $(".zip-search.search-options").on("click", "#btn--search", () => {
    window.location.replace(`/locations/?q=${$("#zipcode").val()}`);
  });

  /****************** CLOSE SITE ALERT ******************/

  $(".alert-message").on("click", ".close-icon", () => {
    $("#site-alert").toggleClass("is-active");
    $(".floating-newsletter").removeClass("site-alert-is-active");
    $("body").toggleClass("notice--show");
    setCookie("SITE_ALERT", "closed", 1);
  });

  /****************** CLOSE NEWSLETTER ******************/

  if (getCookie("NEWSLETTER_WINDOW") !== "closed") {
    $(".floating-newsletter").show();
  }

  $(".floating-newsletter").on("click", ".close-form", () => {
    $(".floating-newsletter").hide();
    setCookie("NEWSLETTER_WINDOW", "closed", 1);
  });

  /****************** ADJUST NEWSLETTER AFTER DISMISSING COOKIE BANNER ******************/

  $(window).on("load", () => {
    $(".cc-btn.cc-dismiss").on("click", () => {
      $(".floating-newsletter").addClass("cookie-dismissed");
    });
  });

  /****************** SET COOKIE FROM DROPDOWN ******************/

  $(".cities-dropdown").on("change", "select", () => {
    const city = $(this).val();
    retrieveLocation(city);
  });

  /****************** OPEN ALL EXTERNAL LINKS IN A NEW TAB ******************/

  $("a").each(function () {
    var href = $(this).attr("href");
    if (
      href &&
      !href.startsWith("#") &&
      !href.startsWith(location.origin) &&
      !href.startsWith("/")
    ) {
      $(this).attr("target", "_blank");
    }
  });

  /****************** SEARCH MAP ******************/

  $(".map-content").on("click", "#btn--search", () => {
    //$(".map-content").css("height", "auto");
    $("#search-results").html(
      '<div class="waiting"><svg class="spinner"><circle cx="20" cy="20" r="18"></circle></svg></div>',
    );

    $(".map-content").addClass("results");

    if (jQuery("#zipcode").val() != "") {
      findByZip(jQuery("#zipcode").val())
        .then((position) => {
          return getLocations(position);
        })
        .then((locations) => {
          return setupLocations(locations);
        })
        .catch((error) => {
          throw new Error(error);
        });
    }
  });

  $("#zipcode").on("keypress", (event) => {
    if (event.key === "Enter") {
      $("#btn--search").click();
    }
  });

  if ($("#btn--search").length > 0) {
    console.log(`looking for selected location data`);
    let selectedLocation = localStorage.getItem(
      `location-${getCookie("LOCATION_ID")}`,
    );
    if (selectedLocation) {
      selectedLocation = JSON.parse(selectedLocation);
    }
    console.log(selectedLocation);
    if (
      selectedLocation &&
      selectedLocation.acf &&
      selectedLocation.acf.utility_data
    ) {
      const address = selectedLocation.acf.utility_data.location;
      if (address && address.zip_code) {
        $("#search-results").html(
          '<div class="waiting"><svg class="spinner"><circle cx="20" cy="20" r="18"></circle></svg></div>',
        );
        $(".map-content").addClass("results");
        findByZip(address.zip_code)
          .then((position) => {
            return getLocations(position);
          })
          .then((locations) => {
            return setupLocations(locations);
          })
          .catch((error) => {
            throw new Error(error);
          });
      }
    }
  }

  if ($("#search-results").length > 0) {
    $(document).on("click", (e) => {
      if (!$(e.target).closest("#search-results").length) {
        // commenting out because this is causing the selected location to go away
        // $("#search-results").hide();
        console.log(`previously search results would have been hidden`);
      }
      if (!$(e.target).closest("#search-results .hours").length) {
        $(".tooltip-container").removeClass("active");
      }
    });
  }

  // Done like this to be able to use after JS loads the content
  function bindHeartEvents() {
    console.log(`Binding heart selection`);
    $(document).on(
      "click",
      ".heart .select-location, .heart .select-heart",
      function (e) {
        console.log(`processing heart select event`);
        const classList = $(this).attr("class").split(" ");
        let selectedLocation = "";
        if (classList.length < 3) {
          selectedLocation = getPostById(classList[1].split("-")[1]);
        } else {
          selectedLocation = getPostById(classList[2].split("-")[1]);
        }
      },
    );

    $(document).on("click", ".unselect-location", function (e) {
      e.preventDefault();
      console.log(`processing heart remove event`);
      const classList = $(this).attr("class").split(" ");
      deleteCookies(classList[1].split("-")[1]);
      $(".menu-item.food-drink-link a").attr("href", `${siteURL}/food-drink/`);
    });
  }
  bindHeartEvents();

  let cookieLocationId = getCookie("LOCATION_ID");
  let currentLocationLocalStorage = localStorage.getItem(
    `location-${cookieLocationId}`,
  );

  if (
    getCookie("LOCATION_ID") !== undefined &&
    currentLocationLocalStorage != null
  ) {
    renderHeader(JSON.parse(currentLocationLocalStorage));
  }

  /* if (
    getCookie("LOCATION_ID") === undefined &&
    getCookie("LOCATION_CLEANED") === undefined
  ) {
    updateLocation();
  } else {
    if (getCookie("LOCATION_ID")) {
      changeFoodLinkToSelectedLocation(getCookie("LOCATION_ID"));
    }
  }*/
});

if (document.getElementById("map")) {
  locationiq.key = "pk.85cb3a8cd4b1782ae988a6341f28ef16";
  mapboxgl.accessToken =
    "pk.eyJ1IjoidGhlaW5maW5pdGVhZ2VuY3kiLCJhIjoiNTJiNWFSMCJ9.rpJ3Ds1mUZHQV2hKPE51Aw";

  let lat = "36.1622767";
  let lng = "-86.7742984";

  if (getCookie("LOCATION_LAT")) {
    lat = getCookie("LOCATION_LAT");
  }
  if (getCookie("LOCATION_LNG")) {
    lng = getCookie("LOCATION_LNG");
  }

  var map = new mapboxgl.Map({
    container: "map",
    attributionControl: false, //need this to show a compact attribution icon (i) instead of the whole text
    zoom: 2,
    style: "mapbox://styles/theinfiniteagency/clabkt2gx005d15o7amqybgds",
    antialias: true,
    center: [lng, lat],
    interactive: true,
  });

  map.scrollZoom.disable();
  map.dragRotate.disable();
  map.touchZoomRotate.disableRotation();
  // map.doubleClickZoom.disable();
  // map.boxZoom.disable();
  if ($(window).width() < 768) {
    map.dragPan.disable();
    $(window).on("load", function (e) {
      $(".mapboxgl-ctrl.mapboxgl-ctrl-group").hide();
    });
  }
  map.keyboard.disable();

  var nav = new mapboxgl.NavigationControl();
  map.addControl(nav, "bottom-right");

  map.on("click", (e) => {
    const regex = /([0-9]+)[^-]/g;
    let m;
    let matchID = "";

    const str = e.originalEvent.srcElement.className;

    while ((m = regex.exec(str)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        matchID = match;
      });
    }
    if (matchID) {
      showLocationOnClick(matchID);
      map.setCenter([e.lngLat.lng, e.lngLat.lat]);
      map.setZoom(6);
      if ($(window).width() > 820) {
        map.panBy([-450, -20]);
      } else {
        map.panBy([0, -100]);
      }

      $(".map-content").addClass("results");
      jQuery("#search-results").show();
    }
  });
}

function initialLocations(question = "") {
  if ("" != question) {
    findByZip(question)
      .then((position) => {
        return getLocations(position);
      })
      .then((locations) => {
        return setupLocations(locations);
      })
      .catch((error) => {
        throw new Error(error);
      });
  } else {
    if (document.getElementById("map")) {
      getAllLocations()
        .then((locations) => {
          if ($(window).width() < 768) {
            map.panBy([0, -150]);
          }
          return setupAllLocations(locations);
        })
        .catch((error) => {
          $("#search-results").html("<div>API Error</div>");
          throw new Error(error);
        });
    }
  }
}

function GetURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split("&");
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split("=");
    if (sParameterName[0] == sParam) {
      return sParameterName[1];
    }
  }

  return null;
}

function setupAllLocations(zips) {
  var x = 0;
  Promise.all(zips).then((locationList) => {
    locationList.forEach((eachLocation) => {
      addMarker(
        eachLocation.locations.acf.coming_soon,
        eachLocation.locations.acf.utility_data.location.coords.lat,
        eachLocation.locations.acf.utility_data.location.coords.lng,
        eachLocation.locations.id,
      );
    });
  });
}

function getLocations(position) {
  return axios.get(urlAPI).then((response) => {
    return orderLocations(response, position);
  });
}

function getAllLocations() {
  return axios.get(urlAPI).then((response) => {
    return orderAllLocations(response);
  });
}

function orderLocations(response, position) {
  let locations = [];

  return new Promise((resolve, reject) => {
    _.forEach(response.data, (location) => {
      locations.push({
        miles: haversineDistance(
          Number(position.coords.latitude),
          Number(position.coords.longitude),
          Number(location.acf.utility_data.location.coords.lat),
          Number(location.acf.utility_data.location.coords.lng),
        ),
        locations: location,
      });
    });

    const results = _.orderBy(locations, ["miles"], "asc");
    map.flyTo({
      center: [
        results[0].locations.acf.utility_data.location.coords.lng,
        results[0].locations.acf.utility_data.location.coords.lat,
      ],
    });

    return resolve(results);
  });
}

function orderAllLocations(response) {
  let locations = [];

  return new Promise((resolve, reject) => {
    _.forEach(response.data, (location) => {
      locations.push({
        title: location.acf.card_title,
        locations: location,
      });
    });
    return resolve(_.orderBy(locations, ["title"], "asc"));
  });
}

function findByZip(zipcode) {
  if (zipcode.length > 0) {
    return new Promise((resolve, reject) => {
      const latLongo = axios
        .get(
          "https://us1.locationiq.com/v1/search?key=" +
            locationiq.key +
            "&q=" +
            zipcode +
            ",usa&format=json",
        )
        .then((response) => {
          return resolve({
            coords: {
              latitude: Number(response.data[0].lat),
              longitude: Number(response.data[0].lon),
            },
          });
        });
    });

    /*  geocoder.geocode(
        {
          address: zipcode,
          componentRestrictions: {
            country: "US",
          },
        },
        (results, status) => {
          if (status == "OK") {
            return resolve({
              coords: {
                latitude: Number(results[0].geometry.location.lat()),
                longitude: Number(results[0].geometry.location.lon()),
              },
            });
          } else {
            jQuery("#search-results").html("");
            jQuery("#search-results").append(
              '<div class="cell col-lg-12 col-md-12 col-sm-12"><div id="no-results" class="row"><div class="accord"><div class="headline"><h3>Geocoder failed</h3></div><div class="answer"></div><div class="line" aria-hidden="true">&nbsp;</div></div></div></div>'
            );

            return reject("Geocoder failed");
          }
        }
      ); */
    //});
  } else {
    jQuery("#search-results").html("");
    jQuery("#search-results").append(
      '<div class="cell col-lg-12 col-md-12 col-sm-12"><div id="no-results" class="row"><div class="accord"><div class="headline"><h3>Geocoder failed</h3></div><div class="answer"></div><div class="line" aria-hidden="true">&nbsp;</div></div></div></div>',
    );
    return reject("Geocoder failed");
  }
}

function setupLocations(zips) {
  //jQuery("#search-results").html("");
  var x = 0;
  Promise.all(zips).then((locationList) => {
    if (locationList[0]) {
      //let search_query = jQuery("#zipcode").val();

      map.setCenter([
        locationList[0].locations.acf.utility_data.location.coords.lng,
        locationList[0].locations.acf.utility_data.location.coords.lat,
      ]);
      map.setZoom(9);
      if ($(window).width() > 820) {
        map.panBy([-450, -20]);
      } else {
        map.panBy([0, -100]);
      }

      renderResults(locationList[0].miles, locationList[0].locations, 1);
    }
    /* locationList.forEach((eachLocation) => {
      x++;

      let total_results = x;
      let search_query = jQuery("#zipcode").val();
      jQuery(".search-total").html(
        `Showing <span class="total-results">${total_results}</span> locations for “${search_query}”`
      );

      renderResults(eachLocation.locations, x);
    }); */
  });
}

function closestLocation(lat, long) {
  return new Promise((resolve, reject) => {
    return resolve({
      coords: {
        latitude: Number(lat),
        longitude: Number(long),
      },
    });
  });
}

function getTheLocations(position) {
  return axios.get(urlAPI).then((response) => {
    return orderTheLocations(response, position);
  });
}

function orderTheLocations(response, position) {
  let locations = [];

  return new Promise((resolve, reject) => {
    _.forEach(response.data, (location) => {
      locations.push({
        miles: haversineDistance(
          Number(position.coords.latitude),
          Number(position.coords.longitude),
          Number(location.acf.utility_data.location.coords.lat),
          Number(location.acf.utility_data.location.coords.lng),
        ),
        locations: location,
      });
    });
    return resolve(_.orderBy(locations, ["miles"], "asc"));
  });
}

function setupTheLocations(locations) {
  Promise.all(locations).then((locationList) => {
    if (locationList[0]) {
      renderHeader(locationList[0].locations);
    }
  });
}

function renderHeader(location) {
  console.log("rendering header");

  localStorage.setItem(
    `location-${location.id}`,
    (localStorage.key = JSON.stringify(location)),
  );

  $(".schedule-direction").removeClass("hidden");

  $(".unactive-location.location-name")
    .addClass("active-location")
    .removeClass("unactive-location")
    .removeClass("only-one");

  // if there are any hearts that need to be selected, go ahead and do that
  $(`.select-location.location-${location.id}`).click();

  $(".active-location.location-name").html(
    `<a href="${location.link}">${location.acf.card_title}</a>`,
  );

  if (location.acf.reservation_link) {
    $(".reservation a").attr("href", location.acf.reservation_link.url);
  }

  $(".schedule .direction").html(
    `<img src="/wp-content/themes/puttery/assets/dist/images/locationPin.svg" class="icon" alt="Directions"><a href="${location.acf.google_map}" target="_blank" rel="nofollow" class="directions">Directions</a>`,
  );

  //console.log(location.id);
  if (location.acf.hero_notice != "") {
    $(".alert-message").html(location.acf.hero_notice);
  }

  /* if (location.acf.google_map) {
    $(".schedule .direction a.directions").attr(
      "href",
      location.acf.google_map
    );
  } */

  $(".schedule-direction .schedule .schedule-icon").html(
    `<img src="/wp-content/themes/puttery/assets/dist/images/information.svg" class="icon" alt="Schedule" /> ${calculateHours(
      location,
    )}`,
  );

  /*   if (!location.acf.allow_reservations) {
    $("a.reservation-btn").addClass("hidden no-transition");
    $(".reservation-mobile").addClass("hidden no-transition");
  } else {
    $("a.reservation-btn").removeClass("hidden no-transition");
    $(".reservation-mobile").removeClass("hidden no-transition");
  }
  $(".location-id-cookie-set").removeClass("d-none");
  $(".location-id-cookie-not-set").addClass("d-none"); */

  deleteCookie("LOCATION_LAT");
  deleteCookie("LOCATION_LNG");
  deleteCookie("LOCATION_ID");
  deleteCookie("LOCATION_CLEANED");

  setCookie("LOCATION_LAT", location.acf.utility_data.location.coords.lat, {
    expires: 30,
  });
  setCookie("LOCATION_LNG", location.acf.utility_data.location.coords.lng, {
    expires: 30,
  });
  setCookie("LOCATION_ID", location.id, { expires: 30 });

  changeFoodLinkToSelectedLocation(location.id);
}

function renderResults(miles, location, index) {
  var coming_soon = "";
  var marker = "pointer-open.svg";
  if (location.acf.coming_soon) {
    coming_soon = `<div class="coming_soon">Coming Soon</div>`;
    marker = "pointer-close.svg";
  }
  let milehtml = "";
  if (miles > 0) {
    milehtml = `<div class="miles">
      <img src="/wp-content/themes/puttery/assets/dist/images/${marker}" class="markerIcon" />
      ${Math.round(miles)}mi
    </div>`;
  }
  //typeof location._embedded === "undefined" && location._embedded

  let location_address = "";
  if (location.acf.google_map) {
    const address = location.acf.utility_data.location;

    location_address = `<a href="${location.acf.google_map}" target="_blank">${address.street_address}, ${address.city} ${address.state.value} ${address.zip_code}</a>`;
  } else {
    location_address = location.acf.hero_info.address;
  }

  if (location.acf.utility_data.location.driveshack) {
    location_address = `${location_address}<br /><small>${location.acf.utility_data.location.driveshack}</small>`;
  }

  let imageURL = "";
  //if (location.featured_media > 0) {
  /* let mediaURL = function (id) {
      return axios.get(`${baseURL}media/${id}`).then((response) => {
        return response;
      });
    };

    let imageMediaURL = mediaURL(location.featured_media);

    imageMediaURL.then(function (result) {
      imageURL = `<img alt="${location.acf.card_title} location" src="${result.data.source_url}" />`;
    }); */

  if (
    typeof location.acf.search_result_image === "undefined" ||
    location.acf.search_result_image === null ||
    !location.acf.search_result_image
  ) {
    imageURL = `<div class="coming-soon--button"><img alt="${location.acf.card_title} location" src="/wp-content/themes/puttery/assets/dist/images/coming-soon.jpg" /></div>`;
  } else {
    imageURL = `<div class="coming-soon--button"><img alt="${location.acf.card_title} location" src="${location.acf.search_result_image.sizes.large}" /></div>`;
  }

  let heart_status = "";
  if (getCookie("LOCATION_ID") == location.id) {
    heart_status = `<div class="heart location-${location.id}"><img src="/wp-content/themes/puttery/assets/dist/images/heart-pink.svg" alt="Heart" class="unselect-location location-${location.id}" /></div>`;
  } else {
    heart_status = `<div class="heart location-${location.id}"><span class="select-location location-${location.id}">Make my location</span><img src="/wp-content/themes/puttery/assets/dist/images/heart.svg" class="inverted select-heart location-${location.id}" alt="Heart" /></div>`;
  }

  let coming_soon_miles_heart = "";
  if (coming_soon != "" && milehtml != "" && heart_status != "") {
    coming_soon_miles_heart = `<div class="two-column">${coming_soon}</div>
  <div class="two-column location-heart">${milehtml}${heart_status}</div>`;
  } else if (coming_soon != "" && milehtml == "" && heart_status != "") {
    coming_soon_miles_heart = `<div class="two-column location-heart">${coming_soon}${heart_status}</div>`;
  } else if (coming_soon == "" && milehtml != "" && heart_status != "") {
    coming_soon_miles_heart = `<div class="two-column location-heart">${milehtml}${heart_status}</div>`;
  } else {
    coming_soon_miles_heart = `<div class="one-column location-heart">${heart_status}</div>`;
  }

  let reservation_link = "";
  if (location.acf.reservation_link) {
    reservation_link = `<div class="reservation-button">
    <a href="${location.acf.reservation_link.url}" class="btn btn-pink hover-black" target="${location.acf.reservation_link.target}">Reserve a Round</a>
  </div>`;
  }

  jQuery("#search-results").html(
    `<div class="row location--cell">
      <div class="cell location--cell-copy">
        <div class="horizontal opener">${coming_soon_miles_heart}</div>
        <div class="title">${location.acf.card_title}</div>
        <div class="horizontal top">
          <div class="address">${location_address}</div>
          <div class="hours">
            <span>HOURS</span>
            ${calculateHours(location)}
          </div>
        </div>
        <div class="horizontal closer">
          ${reservation_link}
          <div class="view-location">
            <a href="${location.link}">View Location</a>
          </div>
        </div>
      </div>
      <div class="cell location--cell-image">${imageURL}</div>
      <img alt="Close Location" src="/wp-content/themes/puttery/assets/dist/images/icon-close.svg" class="close-location">
    </div>
    <script type="text/javascript">
      jQuery("img.close-location").on("click", () => {
        jQuery("#search-results").hide();
        jQuery("#search-results").html('');
        jQuery(".map-content").removeClass("results");
      });

      var hoverOrClick = function () {
        jQuery(".tooltip-container").toggleClass("active");
        jQuery(".tooltip-container").css("top", "55px");

      };

      jQuery("#search-results .hours").click(hoverOrClick);
    </script>`,
  );

  jQuery("#search-results").show();

  // on mobile, lets scroll this result to the top of screen
  if (jQuery(window).width() <= 767) {
    jQuery("html, body").animate(
      {
        scrollTop: jQuery("#search-results").offset().top - 200,
      },
      100,
    );
  } else {
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(".search-options").offset().top - 180,
      },
      100,
    );
  }
}

// fix mobile scrolling offset issues
jQuery(function ($) {
  var offset = jQuery(window).width() <= 767 ? 100 : 0;
  $('a[href*="#"]:not([href="#"])').click(function () {
    var target = $(this.hash);
    offset = jQuery(window).width() <= 767 ? 100 : 0; // update in case of resize since page load
    $("html,body")
      .stop()
      .animate(
        {
          scrollTop: target.offset().top - offset,
        },
        250,
      );
  });
  if (location.hash) {
    var id = $(location.hash);
  }
  $(window).on("load", () => {
    if (location.hash) {
      $("html,body").animate({ scrollTop: id.offset().top - offset }, 100);
    }
  });
});

function addMarker(coming_soon, latitude, longitude, id) {
  var el = document.createElement("div");

  if (coming_soon) {
    el.className = "markerClose location-" + id;
  } else {
    el.className = "markerOpen location-" + id;
  }

  new mapboxgl.Marker(el).setLngLat([longitude, latitude]).addTo(map);
}

function haversineDistance(latA, lngA, latB, lngB) {
  const R = 6371; // 000 // metres //6371e3
  const φ1 = (latA * Math.PI) / 180; // φ, λ in radians
  const φ2 = (latB * Math.PI) / 180;
  const Δφ = ((latB - latA) * Math.PI) / 180;
  const Δλ = ((lngB - lngA) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = (R * c) / 1.60934; // Transform to miles
  return d;
}

function calculateHours(location) {
  const schedule = location.acf.schedule;
  const timezone = location.acf.timezone;

  const todayDate = DateTime.now().setZone(timezone);
  const tomorrowDate = DateTime.now().setZone(timezone).plus({ days: 1 });
  const now = todayDate.ts;
  const today = todayDate.weekdayLong;

  const yesterday = DateTime.now().setZone(timezone).plus({ days: -1 });
  const hour = yesterday.c.hour;

  let dateInformation = "";
  if (schedule) {
    schedule.forEach((element, index) => {
      if (element.day == today) {
        dateInformation = element;
      }
    });
  } else {
    return "Coming Soon";
  }

  const openingBefore = dateInformation["opening"].split(" ");
  const ampmopening = openingBefore[1];
  const openingTimeRaw = openingBefore[0].split(":");

  if (ampmopening == "pm" && openingTimeRaw[0] != 12) {
    openingTimeRaw[0] = parseInt(openingTimeRaw[0]) + 12;
  }

  const openingTime = DateTime.fromObject(
    {
      year: todayDate.c.year,
      month: todayDate.c.month,
      day: todayDate.c.day,
      hour: openingTimeRaw[0],
      minute: openingTimeRaw[1],
    },
    { zone: timezone },
  );
  const openingTimeTS = openingTime.ts;

  const closingBefore = dateInformation["closing"].split(" ");
  const ampm = closingBefore[1];
  const closingTimeRaw = closingBefore[0].split(":");

  let closingTime = DateTime.fromObject(
    {
      year: todayDate.c.year,
      month: todayDate.c.month,
      day: todayDate.c.day,
      hour: closingTimeRaw[0],
      minute: closingTimeRaw[1],
    },
    { zone: timezone },
  );

  let closingTimeTS = closingTime.ts;
  if (ampm == "am") {
    closingTime = DateTime.fromObject(
      {
        year: tomorrowDate.c.year,
        month: tomorrowDate.c.month,
        day: tomorrowDate.c.day,
        hour: closingTimeRaw[0],
        minute: closingTimeRaw[1],
      },
      { zone: timezone },
    );
    closingTimeTS = closingTime.ts;
  }

  let afterTwelve = DateTime.fromObject(
    {
      year: todayDate.c.year,
      month: todayDate.c.month,
      day: todayDate.c.day,
      hour: 23,
      minute: 59,
    },
    { zone: timezone },
  );
  const afterTwelveTS = afterTwelve.ts;

  if (now >= afterTwelveTS && now <= closingTimeTS) {
    console.log("after 12");

    closingTime = DateTime.fromObject(
      {
        year: todayDate.c.year,
        month: todayDate.c.month,
        day: todayDate.c.day,
        hour: closingTimeRaw[0],
        minute: closingTimeRaw[1],
      },
      { zone: timezone },
    );
    closingTimeTS = closingTime.ts;
  }

  let openingTimeCopy = "";

  if (now >= openingTimeTS && now <= closingTimeTS) {
    openingTimeCopy = `Open until <strong>${dateInformation["closing"]}</strong>`;
  } else if (now < openingTimeTS) {
    openingTimeCopy = `Opens at <strong>${dateInformation["opening"]}</strong>`;
  } else if (closingTimeTS > now) {
    openingTimeCopy = `Opens at <strong>${dateInformation["opening"]}</strong>`;
  } else {
    openingTimeCopy = `Opens at <strong>${dateInformation["opening"]}</strong>`;
  }

  const hours = location.acf.hero_info.hours;

  /*





  let groups = [];
  const scheduleHours = location.acf.schedule;
  scheduleHours.forEach(function(hour) {

    const openingDisplay = hour['opening'].split(" ");
    const ampmDisplay = openingDisplay[1];
    const openingDisplayRaw = openingDisplay[0].split(":");

    const openingDisplayDate = DateTime.fromObject(
      {
        year: todayDate.c.year,
        month: todayDate.c.month,
        day: todayDate.c.day,
        hour: openingTimeRaw[0],
        minute: openingTimeRaw[1],
      },
      { zone: timezone }
    );

    let opening = new Date(hour['opening']);
    console.log(hour['opening']);
    console.log(opening);
    opening = opening.getTime();

    let closing = new Date(hour['closing']);
    console.log(hour['closing']);
    console.log(closing);
    closing = closing.getTime();

    const dayName = hour['day'];
    const groupKey = opening + '-' + closing;

    if (!(groupKey in groups)) {
      groups[groupKey] = {
        days: [],
        open: opening,
        close: closing
      };
    }

    const shortDate = new Date(dayName).toLocaleString('en-us', { weekday: 'short' });

    groups[groupKey].days.push(shortDate);
  });

  for (const groupKey in groups) {
    const group = groups[groupKey];
    const days = group.days;
    const open = group.open;
    const close = grouplose;

    console.log(group);
    console.log(days);
    console.log(open);
    console.log(close);

    if (days.length > 1) {
      const startDay = days[0];
      const endDay = days[days.length - 1];
      console.log('<li><span class="day-name">' + startDay + ' - ' + endDay + '</span><span class="day-hours">' + (new Date(open).toLocaleString('en-us', { hour: 'numeric', hour12: true }) + '-' + new Date(close).toLocaleString('en-us', { hour: 'numeric', hour12: true })).toUpperCase() + '</span></li>');
    } else {
      console.log('<li><span class="day-name">' + days[0] + '</span><span class="day-hours">' + (new Date(open).toLocaleString('en-us', { hour: 'numeric', hour12: true }) + '-' + new Date(close).toLocaleString('en-us', { hour: 'numeric', hour12: true })).toUpperCase() + '</span></li>');
    }
  }*/

  let tooltipShow = openingTimeCopy;

  if (hours) {
    tooltipShow += `<div class="tooltip-container"><ul class="day">`;

    hours.forEach((element, index) => {
      tooltipShow += `<li>
      <span class="day-name">${element.day}</span>
      <span class="day-hours">${element.time}</span>
      </li>`;
    });

    tooltipShow += `</ul></div>`;
  }

  return tooltipShow;
}

function retrieveLocation(selected) {
  return axios.get(urlAPI).then((response) => {
    return returnSelected(response, selected);
  });
}

function returnSelected(response, selected) {
  let selectedLocation = [];
  return new Promise((resolve, reject) => {
    _.forEach(response.data, (location) => {
      if (location.acf.card_title == selected) {
        selectedLocation.push({
          lat: location.acf.utility_data.location.coords.lat,
          lng: location.acf.utility_data.location.coords.lng,
          id: location.id,
        });
        renderHeader(location);
      }
    });
    return resolve(selectedLocation);
  });
}

function changeFoodLinkToSelectedLocation(id) {
  return axios.get(`${mainURL}${id}`).then((response) => {
    let slugs = response.data.link.split("/");
    let slug = slugs[4];

    $(".menu-item.food-drink-link a").attr(
      "href",
      `${siteURL}/locations/${slug}/menu/`,
    );
  });
}

function deleteCookies(id) {
  $(".schedule-direction").addClass("hidden");

  deleteCookie("LOCATION_LAT");
  deleteCookie("LOCATION_LNG");
  deleteCookie("LOCATION_ID");
  setCookie("LOCATION_CLEANED", "TRUE", 1);

  /*   $("a.reservation-btn").removeClass("hidden no-transition");
  $(".reservation-mobile").removeClass("hidden no-transition");
  $(".location-id-cookie-set").addClass("d-none");
  $(".location-id-cookie-not-set").removeClass("d-none"); */

  $(".location-heart .heart")
    .html(
      `<span class="select-location location-${id}">Make my location</span>
      <img decoding="async" src="/wp-content/themes/puttery/assets/dist/images/heart.svg" alt="Heart" class="inverted select-heart location-${id}">`,
    )
    .addClass(`location-${id}`);

  $(".active-location.location-name").html(
    `<a href=""/locations/" class="choose-location">Select a Location</a>`,
  );
  // if no location selected, just send them to the main reservations page
  $(".reservation a").attr("href", "https://reservations.puttery.com/");
  bindLocationPrompt();

  $(".active-location.location-name")
    .addClass("unactive-location")
    .addClass("only-one")
    .removeClass("active-location");
}

function getPostById(id) {
  return axios.get(`${mainURL}${id}`).then((response) => {
    return returnPost(response, id);
  });
}

function showLocationOnClick(id) {
  return axios.get(`${mainURL}${id}`).then((response) => {
    return renderResults(0, response.data, 1);
  });
}

function returnPost(response, id) {
  let selectedLocation = [];

  return new Promise((resolve, reject) => {
    selectedLocation = response.data;

    $(".heart").html(
      `<img src="/wp-content/themes/puttery/assets/dist/images/heart-pink.svg" alt="Heart" class="unselect-location location-${id}" />`,
    );

    renderHeader(selectedLocation);

    return resolve(selectedLocation);
  });
}

function promptForLocation() {
  console.log("prompting for location");
  $(".choose-location").addClass("pulse").text("Requesting location");
  navigator.geolocation.getCurrentPosition(
    // if success use the coords
    function (position) {
      console.log(
        `browser provided coordinates: ${position.coords.latitude}. ${position.coords.longitude} - so getting closest location`,
      );
      closestLocation(position.coords.latitude, position.coords.longitude)
        .then((position) => {
          console.log("gettingTheLocations");
          return getTheLocations(position);
        })
        .then((locations) => {
          console.log("settingUpTheLocations");
          return setupTheLocations(locations);
        })
        .catch((error) => {
          console.error(error);
          // if problem then we go by ip address
          lookupLocationByIPAddress();
        });
    },
    // if any issue, lets use ip address
    function (error) {
      console.log("received this error so going by ip address", error);
      lookupLocationByIPAddress();
    },
    {
      timeout: 10000,
    },
  );
}

function bindLocationPrompt() {
  console.log("binding location prompt");
  $(".choose-location").on("click", function (e) {
    console.log("choose location clicked");
    e.preventDefault();
    promptForLocation();
  });
}

if (
  getCookie("LOCATION_ID") === undefined &&
  getCookie("LOCATION_CLEANED") === undefined
) {
  promptForLocation();
} else {
  if (getCookie("LOCATION_ID")) {
    changeFoodLinkToSelectedLocation(getCookie("LOCATION_ID"));
  }
}
bindLocationPrompt();

function lookupLocationByIPAddress() {
  jQuery
    .ajax({
      url: "https://api.ipapi.com/api/check/",
      type: "GET",
      data: {
        access_key: "8f793a2874fdfb4ce0d094d6f848c285",
      },
    })
    .done(function (data, textStatus, jqXHR) {
      console.log("HTTP Request Succeeded: " + jqXHR.status);
      closestLocation(data.latitude, data.longitude) //location.coords.lng
        .then((position) => {
          return getTheLocations(position);
        })
        .then((locations) => {
          return setupTheLocations(locations);
        })
        .catch((error) => {
          throw new Error(error);
        });
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      console.log("HTTP Request Failed");
      $("#search-results").html("<div>API Error</div>");
    })
    .always(function () {});
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name + "=" + (value || "") + expires + "; path=/; SameSite=Strict; Secure";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function deleteCookie(name) {
  document.cookie =
    name +
    "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict; Secure";
}
